import React, {Component, Fragment } from 'react';
import Helmet from 'react-helmet';

// JOHNデザインログイン画面
function getDesign({ design, loading, messageListLogin, errMap, state, webAuthnFlg, toPasskeyLoginMethod,
  autoLoginStateFlg, autoLoginId, handleChangeMethod, swhichPwdShowMethod, handleKeyPressMethod, loginMethod }) {

  // 言語別リンクの設定
  let managerUrl = "";
  let corporateUrl="";
  let selfEmployeeUrl = "";

  // 日の場合
  if(sessionStorage.getItem('lang') === 'ja'){
    managerUrl = process.env.REACT_APP_URL_NOTICE_MANAGER_LOGIN_JA;
    corporateUrl = process.env.REACT_APP_URL_NOTICE_CORPORATE_LOGIN_JA;
    selfEmployeeUrl = process.env.REACT_APP_URL_NOTICE_SELF_EMPLOYEE_LOGIN_JA;
  // 英の場合
  }else{
    managerUrl = process.env.REACT_APP_URL_NOTICE_MANAGER_LOGIN_EN;
    corporateUrl = process.env.REACT_APP_URL_NOTICE_CORPORATE_LOGIN_EN;
    selfEmployeeUrl = process.env.REACT_APP_URL_NOTICE_SELF_EMPLOYEE_LOGIN_EN;
  }

  return (
    <section className="content">
      {(design === "JH001N") ?
        <Helmet
          title={messageListLogin.M001_browserTitle_john} >
        </Helmet> :
        <Helmet
          title={messageListLogin.M001_browserTitle_john_report} >
        </Helmet>}

      { // Loadingモーダル表示
        loading &&
        <div id="loading" className="loading-modal"><img className="loading-img" src={`${process.env.PUBLIC_URL}/assets/img/load.gif`} alt="loading" /></div>
      }

      {/* 画面タイトル表示部 */}
      <div className="ds-heading ds-heading--lg">
        {(design === "JH001N") ?
          <h1 className="ds-heading__title">{messageListLogin.M002_pageTitle_john}</h1> :
          <h1 className="ds-heading__title">{messageListLogin.M002_pageTitle_john_report}</h1>}
      </div>

      <div className="contentInner">
        <p className="ds-text">{messageListLogin.M083_notice027}</p>
        <a href={messageListLogin.M084_noticeUrl007} className="ds-textLink ds-textLink--linkBlank u-fw-bold" target="_blank" rel="noopener noreferrer">
          {messageListLogin.M080_notice026}&nbsp;
          <span className="ds-textLink__icon">
            <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageListLogin.M026_newWindowIcon}>
              <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
            </svg>
          </span>
        </a>

        <div id="JS_error">
          { // エラーメッセージ表示
            (errMap && errMap.ERROR) &&
            <div className="ds-inlineNote ds-inlineNote--attention u-mb-32--pc" role="alert" aria-live="assertive">
              <div className="ds-inlineNote__details">
                <div className="ds-inlineNote__summary">
                  <h2 className="ds-inlineNote__heading">
                    <span className="ds-inlineNote__headingIcon">
                      <svg className="ds-icon" width="30" height="30" role="img" aria-label={messageListLogin.M003_errorIconText}>
                        <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_attention`}></use>
                      </svg>
                    </span>
                    <span className="ds-inlineNote__headingLabel">{messageListLogin.M004_errorBoxTitle}</span>
                  </h2>
                </div>
                <div className="ds-inlineNote__content">
                  <p className="ds-text">{errMap.ERROR}</p>
                </div>
              </div>
            </div>
          }
        </div>

        <div className="formPanel">
          <div className="formPanel__inner formPanel__inner--split">
            {/* 画面項目表示部 */}
            <div className="ds-heading ds-heading--sm u-al-center--pc">
              <h2 className="ds-heading__title">{messageListLogin.M075_passwordTitle}</h2>
            </div>

            <form name="form">
              <div className="formList">
                {/* お得意様番号（通常入力） */}
                {
                  (!autoLoginStateFlg) &&
                  <div className="formList__line">
                    <div className="formWrap">
                      <label className="formLabel" htmlFor="LB_input-jmbnumber-1">
                        <span className="formLabel__text">{messageListLogin.M005_id}</span>
                      </label>
                      <input type="text" id="LB_input-jmbnumber-1" name="id"
                        className={errMap && errMap.errorId === 'id' ? "ds-textfield is-error" : "ds-textfield"}
                        maxLength="9" inputMode="numeric" autoComplete="username" required
                        aria-invalid={errMap && errMap.errorId === 'id' ? "true" : "false"}
                        aria-describedby="LB_input-jmbnumber-1-helper"
                        defaultValue={state.fillinId} value={state.id} onChange={handleChangeMethod} />
                      <span className="helperText" id="LB_input-jmbnumber-1-helper">{messageListLogin.M091_helperText}</span>
                    </div>
                  </div>
                }
                {/* お得意様番号（オートログイン時 読み取り専用） */}
                {
                  (autoLoginStateFlg) &&
                  <div className="formList__line">
                    <div className="formWrap">
                      <label className="formLabel" htmlFor="LB_input-jmbnumber-2">
                        <span className="formLabel__text">{messageListLogin.M005_id}</span>
                      </label>
                      <input type="text" id="LB_input-jmbnumber-2"
                        className="ds-textfield"
                        maxLength="9" inputMode="numeric" autoComplete="username" required
                        aria-invalid="false" aria-describedby="LB_input-jmbnumber-2-helper"
                        readOnly defaultValue={autoLoginId} tabIndex="-1" />
                      <span className="helperText" id="LB_input-jmbnumber-2-helper">{messageListLogin.M091_helperText}</span>
                    </div>
                  </div>
                }

                {/* パスワード */}
                <div className="formList__line">
                  <div className="formWrap">
                    <label className="formLabel" htmlFor="LB_input-password">
                      <span className="formLabel__text">{messageListLogin.M006_password}</span>
                    </label>
                    <input type={state.showPwd ? "text" : "password"} id="LB_input-password" name="password"
                      className={errMap && errMap.errorId === 'password' ? "ds-textfield is-error" : "ds-textfield"}
                      maxLength="256" required autoComplete="current-password"
                      aria-invalid={errMap && errMap.errorId === 'password' ? "true" : "false"}
                      value={state.password} onChange={handleChangeMethod}
                      onKeyPress={handleKeyPressMethod} />

                    {/* パスワードを表示する */}
                    <label className="ds-checkbox">
                      <input className="ds-checkbox__input" type="checkbox" name="checkPassword"
                        aria-controls="LB_input-password" onChange={swhichPwdShowMethod} />
                      <span className="ds-checkbox__partsWrap">
                        <span className="ds-checkbox__parts" role="presentation"></span>
                        <span className="ds-checkbox__text">{messageListLogin.M008_showPassword}</span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>

              {/* パスワードを初期化する */}
              <div className="textLinkList u-mt-32">
                <a href={"./pwd_reset?design=" + sessionStorage.getItem('design') + "&lang=" + sessionStorage.getItem('lang')}
                  className="ds-textLink ds-textLink--linkBlank u-fw-bold"
                  target="_blank" rel="noopener noreferrer">
                  {messageListLogin.M010_resetPassword}&nbsp;
                  <span className="ds-textLink__icon">
                    <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageListLogin.M026_newWindowIcon}>
                      <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                    </svg>
                  </span>
                </a>
              </div>

              {/* 操作ボタン表示部 */}
              <div className="buttonLayout">
                <div className="buttonWrap buttonWrap--center">
                  <div className="ds-button ds-button--primary ds-button--large">
                    <button className="ds-button__trigger" type="button" formNoValidate onClick={loginMethod}>
                      <span className="ds-button__label">{messageListLogin.M011_login}</span>
                    </button>
                  </div>
                </div>
              </div>

              {/* パスワードリセットリンク */}
              <div className="textLinkList u-mt-32">
                <a href={managerUrl} className="ds-textLink ds-textLink--linkBlank u-fw-bold"
                  target="_blank" rel="noopener noreferrer">
                  {messageListLogin.M055_linkJmbLogin}&nbsp;
                  <span className="ds-textLink__icon">
                    <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageListLogin.M026_newWindowIcon}>
                      <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                    </svg>
                  </span>
                </a>
                <a href={corporateUrl} className="ds-textLink ds-textLink--linkBlank u-fw-bold"
                  target="_blank" rel="noopener noreferrer">
                  {messageListLogin.M056_linkCorporateLogin}&nbsp;
                  <span className="ds-textLink__icon">
                    <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageListLogin.M026_newWindowIcon}>
                      <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                    </svg>
                  </span>
                </a>
                <a href={selfEmployeeUrl} className="ds-textLink ds-textLink--linkBlank u-fw-bold"
                  target="_blank" rel="noopener noreferrer">
                  {messageListLogin.M057_linkSelfLogin}&nbsp;
                  <span className="ds-textLink__icon">
                    <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageListLogin.M026_newWindowIcon}>
                      <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                    </svg>
                  </span>
                </a>
              </div>
            </form>
          </div>

          <div className="formPanel__inner formPanel__inner--split">
            {/* パスキー認証 */}
            <div className="ds-heading ds-heading--sm u-al-center--pc">
              <h2 className="ds-heading__title">{messageListLogin.M076_passkeyTitle}</h2>
            </div>
            <p className="ds-text ds-text--md ds-text--note">{messageListLogin.M077_notice024}</p>

            <div className="u-mt-24 u-mb-32 u-al-center">
              <img src={`${process.env.PUBLIC_URL}/assets/img/icon_passkey.svg`} className="u-img-full" alt="" aria-hidden="true" />
            </div>

            <div className="buttonLayout">
              <div className="buttonWrap buttonWrap--center">
                {(!webAuthnFlg) &&
                  <div className="buttonWrap__text">
                    <p className="ds-text u-fz-12">{messageListLogin.M078_notice025}</p>
                  </div>
                }
                <div className={webAuthnFlg ? "ds-button ds-button--secondary ds-button--large" : "ds-button ds-button--secondary ds-button--large is-disabled"}>
                  <button
                    className={webAuthnFlg ? "ds-button__trigger" : "ds-button__trigger ds-button__trigger--disabled"}
                    type="button" disabled={!webAuthnFlg} onClick={toPasskeyLoginMethod}>
                    <span className="ds-button__label">{messageListLogin.M079_login}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* リンク表示部 */}
      <div className="contentInner">
        <div className="ds-heading ds-heading--sm">
          <h2 className="ds-heading__title">{messageListLogin.M013_notices}</h2>
        </div>
        <ul className="ds-listText ds-listText--md">
          <li className="ds-listText__item">{messageListLogin.M058_notice013}
            <a href="https://www.jal.co.jp/jp/ja/jmb/jmb-login/number-info/" className="ds-textLink ds-textLink--linkBlank u-fw-bold"
              target="_blank" rel="noopener noreferrer">
              &nbsp;{messageListLogin.M059_notice014}&nbsp;
              <span className="ds-textLink__icon">
                <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageListLogin.M026_newWindowIcon}>
                  <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                </svg>
              </span>
            </a>
            &nbsp;{messageListLogin.M060_notice015}
          </li>
          <li className="ds-listText__item">{messageListLogin.M018_notice005}<br />
            {messageListLogin.M019_notice006}
          </li>
          <li className="ds-listText__item">{messageListLogin.M020_notice007}<br />
            <a href="https://www.jal.co.jp/jp/ja/jmb/jmb-login/number-info/" className="ds-textLink ds-textLink--linkBlank u-fw-bold"
              target="_blank" rel="noopener noreferrer">
              {messageListLogin.M021_notice008}&nbsp;
              <span className="ds-textLink__icon">
                <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageListLogin.M026_newWindowIcon}>
                  <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                </svg>
              </span>
            </a>
          </li>
          <li className="ds-listText__item">{messageListLogin.M061_notice016}
            <a href="https://www.jal.co.jp/jalonline/policy/browser.html" className="ds-textLink ds-textLink--linkBlank u-fw-bold"
              target="_blank" rel="noopener noreferrer">
              &nbsp;{messageListLogin.M062_notice017}&nbsp;
              <span className="ds-textLink__icon">
                <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageListLogin.M026_newWindowIcon}>
                  <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                </svg>
              </span>
            </a>
            &nbsp;{messageListLogin.M063_notice018}
          </li>
          <li className="ds-listText__item">{messageListLogin.M064_notice019}
            <a href="https://www.jal.co.jp/jalonline/rule/security.html" className="ds-textLink ds-textLink--linkBlank u-fw-bold"
              target="_blank" rel="noopener noreferrer">
              &nbsp;{messageListLogin.M065_notice020}&nbsp;
              <span className="ds-textLink__icon">
                <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageListLogin.M026_newWindowIcon}>
                  <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                </svg>
              </span>
            </a>
            &nbsp;{messageListLogin.M066_notice021}
          </li>
          <li className="ds-listText__item">{messageListLogin.M022_notice009}</li>
          <li className="ds-listText__item">{messageListLogin.M067_notice022}<br />
            <a href="https://www.jal.co.jp/cgi-bin/jal/jmb/enroll/index.cgi" className="ds-textLink ds-textLink--linkBlank u-fw-bold"
              target="_blank" rel="noopener noreferrer">
              {messageListLogin.M068_notice023}&nbsp;
              <span className="ds-textLink__icon">
                <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageListLogin.M026_newWindowIcon}>
                  <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                </svg>
              </span>
            </a>
          </li>
        </ul>
      </div>
    </section>
  );
}

export { getDesign }